import { Group, GridHelper, Color } from 'three';
import BasicLights from './Lights.js';
import Cube from './Cube/Cube.js';

export default class SeedScene extends Group {
  constructor() {
    super();

    const lights = new BasicLights();

    this.scene_cubes = []; // List of Cube objects
    this.filled_cube_coordinates = []; // List of filled coordinates. Updated as and when a new cube is added
    this.cube_pieces = {};


    const gridsize = 20;
    const griddivisions = 20;

    const gridHelper = new GridHelper( gridsize, griddivisions, new Color('black'), new Color('black'));

    //this.add(land, flower, lights);
    this.add(lights, gridHelper);
  }

  update(timeStamp) {
    //this.rotation.y = timeStamp / 10000;
  }

  addNewCube(gridx, gridy, gridz){
    // Don't allow outside positive quadrant addition
    if(gridx >=0 && gridy >=0 && gridz >=0)
    {
      if(!this.filled_cube_coordinates.includes(`${gridx}-${gridy}-${gridz}`))
      {
        var cube = new Cube(gridx, gridy, gridz);
        this.filled_cube_coordinates.push(`${gridx}-${gridy}-${gridz}`);
        this.scene_cubes.push(cube);
        //console.log(cube);
        this.add(cube);
        return cube;
      }
      else
      {
        console.warn(`${gridx}-${gridy}-${gridz} already in the scene!`);
      }
    }
    else
    {
      console.log("No negative grid positions allowed!");
    }
    
  }

  buildGridData(){
    var grid_data = {};
    var grids = [];
    for(var i=0; i<this.scene_cubes.length; i++){
        var grid  = {
          localPos : {
            x : this.scene_cubes[i].gridx,
            y : this.scene_cubes[i].gridy,
            z : this.scene_cubes[i].gridz
          }
        }
        grids.push(grid);
    }
    return grids;
  }

  buildPiecesData(){
    
    console.log(this.cube_pieces);
    var pieces = [];
    for(var hexcolor in this.cube_pieces){
      var grids = [];
      for(var i=0; i<this.cube_pieces[hexcolor].length; i++){
        var grid  = {
            localPos : {
              x : this.cube_pieces[hexcolor][i].gridx,
              y : this.cube_pieces[hexcolor][i].gridy,
              z : this.cube_pieces[hexcolor][i].gridz
          }
        }
        grids.push(grid);
      }
      var color_seg = {
        color : hexcolor,
        segments : grids
      }
      pieces.push(color_seg);
    }
    return pieces;
  }

  setCubePieceColor(pieceColor, cubeObject){
		cubeObject.cube_color = new Color(pieceColor[0]/255., pieceColor[1]/255., pieceColor[2]/255.);
		cubeObject.cube_color_hex = cubeObject.cube_color.getHexString().toUpperCase();
		cubeObject.materials.forEach(element => {
			element.color.set(cubeObject.cube_color);
			element.transparent = false;
		});

    // Add to the color pieces dictionary
    if(!(cubeObject.cube_color_hex in this.cube_pieces)){
      this.cube_pieces[cubeObject.cube_color_hex] = [];
      this.cube_pieces[cubeObject.cube_color_hex].push(cubeObject);
    }
    else{
      this.cube_pieces[cubeObject.cube_color_hex].push(cubeObject);
    }
	}

  // Used to clear all the pieces for the puzzle
  clearPiecesColor(){
    this.scene_cubes.forEach(cube => {
      cube.cube_color = new Color('gray');
      cube.cube_color_hex = cube.cube_color.getHexString().toUpperCase();
      cube.materials.forEach(mat => {
        mat.color.set('gray');
        mat.transparent = true;
      });
    });
    this.cube_pieces = {};
  }

  // Used to clear pieces of a particular color
  clearPiecesOfColor(color){
    var color_hex = color.getHexString().toUpperCase();
    this.cube_pieces[color_hex].forEach(cube => {
      cube.cube_color = new Color('gray');
      cube.cube_color_hex = cube.cube_color.getHexString().toUpperCase();
      cube.materials.forEach(mat => {
        mat.color.set('gray');
        mat.transparent = true;
      });
    });
    this.cube_pieces[color_hex] = [];
  }

  // Create puzzle from file
  createPuzzleFromFile(puzzleJSON){
    var grid = puzzleJSON['grid'];
    var pieces = puzzleJSON['pieces'];

    var gridCubeMap = {};
    grid.forEach(gridElement => {
      // Create the piece
      var key = `${gridElement['localPos']['x']}-${gridElement['localPos']['y']}-${gridElement['localPos']['z']}`;
      var cube = this.addNewCube(gridElement['localPos']['x'], gridElement['localPos']['y'], gridElement['localPos']['z']);
      gridCubeMap[key] = cube;
    });

    pieces.forEach(piece => {
      // Color the pieces
      var segmentColor = piece['color'];
      var bigint = parseInt(segmentColor, 16);
      var r = (bigint >> 16) & 255;
      var g = (bigint >> 8) & 255;
      var b = bigint & 255;
      
      var colorInRGB = new Color(r,g,b);
      piece['segments'].forEach(segmentPiece => {
        // Color the piece
        var key = `${segmentPiece['localPos']['x']}-${segmentPiece['localPos']['y']}-${segmentPiece['localPos']['z']}`;
        var storedCube = gridCubeMap[key];
        this.setCubePieceColor([colorInRGB.r, colorInRGB.g, colorInRGB.b], storedCube);
      });
    });
  }

  // Used to clear all the pieces in the puzzle (Destroy them)
  destroyAllPieces(){
    
  }
}